import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const BarContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    width: 100%;
    padding-bottom: 8px;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${Colors.Black.V50};
`;

export const tooltipStyle = css`
    .ant-popover-inner {
        border-radius: 6px;
    }
`;

export const BarItem = styled.div<{ width: string }>`
    width: ${({ width }) => width};
    height: 16px;
    background: ${Colors.Black.V50};
    border-radius: 0 4px 4px 0;

    &:hover,
    &:focus {
        background: ${Colors.Yellow.V200};
    }
`;

export const KeyContainer = styled.span`
    text-transform: capitalize;
`;
